"use client";

import { CircleDot } from "lucide-react";
import { AddToCartButton, EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 1,
  orderby: "date",
  order: "desc" as const
};
const wp_query = new WP_Query(wp_query_params);
const specCallouts = [{
  label: "BERGAMOT / TOP",
  top: "18%",
  left: "12%"
}, {
  label: "JASMINE / HEART",
  top: "42%",
  left: "8%"
}, {
  label: "SANDALWOOD / BASE",
  top: "68%",
  left: "16%"
}, {
  label: "HAND-BLOWN GLASS",
  top: "30%",
  left: "55%"
}];
const techSpecs = [{
  label: "CONCENTRATION",
  value: "PARFUM"
}, {
  label: "NOTES",
  value: "FLORAL, WOODY"
}, {
  label: "LONGEVITY",
  value: "12+ HOURS"
}, {
  label: "PROJECTION",
  value: "MODERATE"
}, {
  label: "VOLUME",
  value: "100 ML"
}, {
  label: "PRICE",
  value: "$280"
}];
const marqueeText = ["ARTISANAL", "SMALL-BATCH", "ARTISANAL", "SMALL-BATCH", "ARTISANAL", "SMALL-BATCH", "ARTISANAL", "SMALL-BATCH"];
function FlagshipProductConsumer() {
  const {
    products,
    loading
  } = useEcommerceProducts();
  const product = products[0];
  return <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      {}
      <div className="relative lg:col-span-7 lg:-ml-12 xl:-ml-24">
        <div className="relative aspect-[4/5] lg:aspect-[5/6] overflow-hidden bg-muted">
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-lg pointer-events-none" style={{
          background: "radial-gradient(circle, hsla(15, 35%, 65%, 0.3) 0%, hsla(15, 35%, 65%, 0.1) 40%, transparent 70%)",
          filter: "blur(80px)"
        }} />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] rounded-lg pointer-events-none" style={{
          background: "radial-gradient(circle, hsla(15, 35%, 65%, 0.5) 0%, transparent 60%)",
          filter: "blur(40px)"
        }} />

          {product?.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="relative z-10 w-full h-full object-cover" loading="lazy" /> : <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701222/img/signature_perfume_bottle.png" alt="Essence & Co. signature perfume bottle" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701222/img/signature_perfume_bottle.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701222/img/signature_perfume_bottle.png-wvc-sizes" className="relative z-10 w-full h-full object-cover" loading="lazy" />}

          {}
          {specCallouts.map((callout, i) => <div key={i} data-index={i} className="hidden md:flex absolute z-20 items-center gap-3" style={{
          top: callout.top,
          left: callout.left
        }}>
              <div className="w-12 h-px bg-primary" />
              <div className="px-3 py-2 border border-primary/40 font-mono text-[10px] tracking-widest uppercase text-foreground" style={{
            backgroundColor: "hsla(0, 0%, 100%, 0.5)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)"
          }}>
                {callout.label}
              </div>
            </div>)}
        </div>
      </div>

      {}
      <div className="lg:col-span-5 lg:sticky lg:top-24 space-y-8">
        <div className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">
          COLLECTION / 2024
        </div>

        <h2 className="font-default font-bold text-6xl md:text-7xl leading-[0.9] tracking-tighter text-foreground">
          {loading ? "ESSENCE" : product?.title?.toUpperCase() || "ESSENCE"}
          <span className="text-primary">NO.1</span>
        </h2>

        <p className="font-serif text-lg leading-relaxed text-muted-foreground max-w-[60ch]">
          Crafted over twelve months of olfactory refinement. Rare botanicals sourced from the Mediterranean coast, distilled into a singular, evocative scent. Essence No.1 is not merely a fragrance — it is a sensory narrative, bottled in hand-blown glass and sealed by hand for the discerning individual.
        </p>

        {}
        <div className="border border-border">
          {techSpecs.map((spec, i) => <div key={i} data-index={i} className="grid grid-cols-2 border-b border-border last:border-b-0">
              <div className="px-4 py-3 font-mono text-[11px] tracking-widest uppercase text-muted-foreground border-r border-border">
                {spec.label}
              </div>
              <div className="px-4 py-3 font-mono text-[11px] tracking-widest uppercase text-foreground">
                {spec.value}
              </div>
            </div>)}
        </div>

        {}
        <div className="flex flex-col sm:flex-row gap-3">
          {product ? <AddToCartButton productId={product.id} className="w-full sm:w-auto" buttonClassName="bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs tracking-[0.2em] uppercase px-8 h-14 rounded-none" text="ADD TO COLLECTION →" showQuantity={false} /> : <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs tracking-[0.2em] uppercase px-8 h-14">
              ADD TO COLLECTION →
            </Button>}
          <Link to="/OurHeritagePage">
            <Button variant="outline" className="w-full sm:w-auto border-border bg-transparent text-foreground hover:bg-secondary font-mono text-xs tracking-[0.2em] uppercase px-8 h-14">
              OUR HERITAGE
            </Button>
          </Link>
        </div>

        {}
        <div className="flex items-center gap-3 pt-4 border-t border-border">
          <span className="relative flex items-center justify-center">
            <span className="absolute inline-flex h-3 w-3 rounded-lg bg-primary opacity-75 animate-ping" />
            <CircleDot className="relative h-3 w-3 text-primary" />
          </span>
          <span className="font-mono text-xs tracking-[0.2em] uppercase text-foreground">
            LIMITED BATCH · 3 UNITS REMAINING
          </span>
        </div>
      </div>
    </div>;
}
export default function ScentOfTheMonth() {
  return <section data-section-id="2208" id="scent-of-the-month" className="relative bg-background text-foreground overflow-hidden py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <EcommerceProductsProvider wp_query={wp_query}>
          <FlagshipProductConsumer />
        </EcommerceProductsProvider>
      </div>

      {}
      <div className="mt-32 border-t border-border overflow-hidden">
        <div className="flex whitespace-nowrap py-5 animate-[marquee_30s_linear_infinite] opacity-50">
          {marqueeText.concat(marqueeText).map((word, i) => <span key={i} data-index={i} className="font-mono text-sm tracking-[0.3em] uppercase text-foreground mx-8 flex items-center gap-8">
              {word}
              <span className="text-primary">·</span>
            </span>)}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}